import { render, staticRenderFns } from "./form11.vue?vue&type=template&id=5aaa8b1c&scoped=true&"
import script from "./form11.vue?vue&type=script&lang=js&"
export * from "./form11.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aaa8b1c",
  null
  
)

export default component.exports